// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  IAddMasterPassRequest,
  useAddMasterPass,
  useAuthorization,
  useGetAllMerchantList,
  useUpdateMasterPass,
} from "../../../hooks";
import {
  Autocomplete,
  FormControl,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Stack } from "@mui/system";
import { Button, Loading } from "../../atoms";
import { useUserInfo } from "../../../store/User.state";
import { InputControl, SwitchControl } from "../../molecules";
import { Controller, useForm } from "react-hook-form";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import {
  getMasterPassFormSchema,
  masterPassAddFormSchema,
  MasterPassAddFormSchemaFormValuesType,
  masterPassAddInitialValues,
} from "./_formTypes";
import { zodResolver } from "@hookform/resolvers/zod";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";

export const MasterPassAddForm = () => {
  const navigate = useNavigate();
  const { showCreate } = useAuthorization();
  const [selectedMerchantId, setSelectedMerchantId] = useState(0);
  const [userInfo] = useUserInfo();
  const theme = useTheme();
  const masterPassProfile = useLocation()
    .state as unknown as IAddMasterPassRequest;
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const isUpdate =
    masterPassProfile &&
    masterPassProfile?.id &&
    Number(masterPassProfile?.id) > 0;

  const { control, reset, handleSubmit, watch } =
    useForm<MasterPassAddFormSchemaFormValuesType>({
      resolver: zodResolver(getMasterPassFormSchema(isUpdate)),
      defaultValues: masterPassAddInitialValues,
      mode: "onChange",
    });
  const setSnackbar = useSetSnackBar();
  const { mutate: addMasterPass, isLoading: addLoading } = useAddMasterPass();
  const { mutate: updateMasterPass, isLoading: updateLoading } =
    useUpdateMasterPass();
  const { data: rawMerchantList, isLoading: merchantListLoading } =
    useGetAllMerchantList("ACTIVE");

  const merchantList = useMemo(() => {
    if (userInfo.merchantId == 0) {
      return rawMerchantList?.data?.map(
        (rawPosType: { merchantName: string; merchantId: number }) => {
          return {
            label: rawPosType.merchantName + ` (${rawPosType.merchantId})`,
            value: rawPosType.merchantId,
          };
        }
      );
    } else {
      return rawMerchantList?.data
        ?.filter((rawPosType: { merchantName: string; merchantId: number }) => {
          return rawPosType.merchantId === Number(userInfo.merchantId);
        })
        .map((filteredMerchant) => {
          return {
            label: filteredMerchant.merchantName + ` (${filteredMerchant.merchantId})`,
            value: filteredMerchant.merchantId,
          };
        });
    }
  }, [rawMerchantList?.data, userInfo?.merchantId]);

  const onSubmit = ({
    merchantId,
    restriction,
    clientId,
    encKey,
    macKey,
    terminalGroupId,
  }: MasterPassAddFormSchemaFormValuesType) => {
    const request = {
      merchantId,
      restriction,
      clientId: +clientId,
      encKey,
      macKey,
      terminalGroupId,
    };

    if (masterPassProfile && Number(masterPassProfile?.id) > 0) {
      updateMasterPass(
        {
          ...request,
          id: masterPassProfile.id,
        },
        {
          onSuccess: (data) => {
            if (data.isSuccess) {
              localStorage.setItem("fromEditPage", "true");
              navigate("/merchant-management/masterpass-identification");
              setSnackbar({
                severity: "success",
                isOpen: true,
                description: data.message,
              });
            } else {
              setSnackbar({
                severity: "error",
                description: data.message,
                isOpen: true,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              description: "İşlem sırasında bir hata oluştu",
              isOpen: true,
            });
          },
        }
      );
    } else {
      addMasterPass(request, {
        onSuccess: (data) => {
          if (data.isSuccess) {
            navigate("/merchant-management/masterpass-identification");
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: data.message,
            });
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      });
    }
  };

  useEffect(() => {
    if (!!masterPassProfile && JSON.stringify(masterPassProfile) !== "{}") {
      reset({
        merchantId: masterPassProfile.merchantId,
        restriction: masterPassProfile.restriction,
        clientId: `${masterPassProfile?.clientId}`,
        encKey: masterPassProfile.encKey,
        macKey: masterPassProfile.macKey,
        terminalGroupId: masterPassProfile.terminalGroupId,
      });
    }
  }, [masterPassProfile, reset]);

  const handleBack = () =>
    navigate("/merchant-management/masterpass-identification");
  const hasLoading = addLoading || updateLoading || merchantListLoading;

  return (
    <>
      {hasLoading ? (
        <Loading />
      ) : (
        <Stack flex={1} justifyContent="space-between">
          <Stack flex={1} p={2}>
            <Stack spacing={4}>
              <Stack
                width={isDesktop ? 800 : "auto"}
                spacing={3}
                direction="row"
              >
                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                  {merchantList && (
                    <Controller
                      control={control}
                      name="merchantId"
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <Autocomplete
                          sx={{ mr: isDesktop ? 0 : 0 }}
                          id="merchantId"
                          disabled={masterPassProfile?.merchantId}
                          options={merchantList}
                          value={
                            merchantList.find(
                              (option) => option.value === value
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            const merchantValue = newValue
                              ? Number(newValue.value)
                              : null;
                            onChange(merchantValue);
                            setSelectedMerchantId(merchantValue);
                          }}
                          getOptionLabel={(option: {
                            label: string;
                            value: number;
                          }) => option.label}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Üye İşyeri"
                              error={!!error} // eğer bir hata varsa error prop'u true olacaktır
                            />
                          )}
                        />
                      )}
                    />
                  )}
                </FormControl>
                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                  <SwitchControl
                    label="Yetki"
                    control={control}
                    id="restriction"
                  />
                </FormControl>
              </Stack>
              <Stack
                spacing={3}
                width={isDesktop ? 800 : "auto"}
                direction={isDesktop ? "row" : "column"}
              >
                <FormControl sx={{ flex: 1 }}>
                  <InputControl
                    numeric
                    id="clientId"
                    control={control}
                    label="MasterPass Üye İşyeri Numarası "
                  />
                </FormControl>
                <FormControl sx={{ flex: 1 }}>
                  <InputControl id="encKey" control={control} label="EncKey" />
                </FormControl>
              </Stack>
              <Stack
                spacing={3}
                width={isDesktop ? 800 : "auto"}
                direction={isDesktop ? "row" : "column"}
              >
                <FormControl sx={{ flex: 1 }}>
                  <InputControl id="macKey" control={control} label="MacKey " />
                </FormControl>
                <FormControl sx={{ flex: 1 }}>
                  <InputControl
                    id="terminalGroupId"
                    control={control}
                    label="MasterPass Terminal Grup Id "
                  />
                </FormControl>
              </Stack>
            </Stack>
          </Stack>
          <Stack
            borderTop="1px solid #E6E9ED"
            py={2}
            pr={2}
            direction="row"
            justifyContent="flex-end"
          >
            {!showCreate && (
              <Button
                onClick={handleSubmit(onSubmit)}
                variant="contained"
                text={
                  masterPassProfile && masterPassProfile.id > 0
                    ? "Güncelle"
                    : "Kaydet"
                }
              />
            )}

            <Button onClick={handleBack} sx={{ mx: 2 }} text={"Iptal"} />
          </Stack>
        </Stack>
      )}
    </>
  );
};
